import React, { useCallback, useMemo } from 'react';

import { Search } from 'lucide-react';
import UDInput from 'ud-form/components/input/component';
import UDPerPage from 'ud-ui/components/per-page/per-page';
import classNames from 'classnames';
import debounce from 'shared/utils/debounce';
import { theme } from 'styles/theme/theme';

type Props = {
  className?: string;

  perPage: number;
  onChangePerPage?: (value: number) => void;

  onFilter?: (value: string) => void;
  value: string | null;

  placeholder?: string;
};

function Filter(props: Props) {
  const { onFilter, className, value, perPage, onChangePerPage, placeholder } = props;

  const handleChangeSearch = useMemo(
    () =>
      debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        onFilter?.(e.target.value);
      }, 300),
    [onFilter],
  );

  const handleChangeResultsOnPage = useCallback(
    (value: number) => {
      onChangePerPage?.(value);
    },
    [onChangePerPage],
  );

  return (
    <div className={classNames('d-flex justify-content-between mb-6', className)}>
      <div className="col-5">
        <UDInput
          value={value ?? ''}
          placeholder={placeholder}
          onChange={handleChangeSearch}
          iconProps={{
            position: 'icon-left',
            component: <Search size={16} color={theme.colors.SurfaceRomanSilver30} />,
          }}
        />
      </div>
      <UDPerPage value={perPage} onChange={handleChangeResultsOnPage} />
    </div>
  );
}

export default Filter;
